import { render, staticRenderFns } from "./client-orders-menu.vue?vue&type=template&id=881b166c&"
import script from "./client-orders-menu.vue?vue&type=script&lang=js&"
export * from "./client-orders-menu.vue?vue&type=script&lang=js&"
import style0 from "./client-orders-menu.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports